import { render, staticRenderFns } from "./CongratulationAndWarning.vue?vue&type=template&id=7c9d2db3&"
import script from "./CongratulationAndWarning.vue?vue&type=script&lang=js&"
export * from "./CongratulationAndWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports